<template>
  <div class="onlineSelling">
    <template-form
      :isBack="true"
      title="เปรียบเทียบการเสียภาษี"
      description="ระหว่างบุคคลธรรมดาและนิติบุคคลว่าต่างกันอย่างไร"
    >
      <div class="ib-detail">
        <h4>รายรับและต้นทุนของธุรกิจคุณ</h4>
      </div>

      <div class="ib-answer">
        {{ jobIncomeLable }}
        <currency v-model="onlineSelling" v-on:change="setOnlineSelling" />
      </div>
      <div class="ib-answer">
        รายได้จากเงินเดือนต่อเดือน
        <currency v-model="salary" v-on:change="setIncomeSalary" />
      </div>
      <div class="ib-answer">
        {{ jobCostLable }}
        <currency v-model="cost" v-on:change="setCost" />
      </div>

      <div class="ib-footer">
        <chevron-right-link
          :disabled="!validate"
          @clickLink="goExpense"
          caption="ถัดไป"
        />
      </div>
    </template-form>

    <div class="i-loading">
      <div class="il-active" />
    </div>
    <StateAnswer />
  </div>
</template>

<script>
import StateAnswer from "@/components/StateAnswer.vue";

export default {
  name: "Income",
  components: {
    StateAnswer,
  },
  data() {
    const onlineSelling = this.$store.getters["taxInfo/getIncome"]
      .onlineSelling;
    const salary = this.$store.getters["taxInfo/getIncome"].salary;
    const cost = this.$store.getters["taxInfo/getExpense"].cost;

    const jobIncomeLable = "รายได้จากการขายสินค้าต่อเดือน (ไม่รวม VAT)";

    const jobCostLable = "ต้นทุนสินค้าต่อเดือน (ไม่รวม VAT)";

    return {
      onlineSelling,
      cost,
      salary,
      jobIncomeLable,
      jobCostLable,
    };
  },
  methods: {
    goExpense() {
      this.$router.push({ path: "/forms/expense" });
    },
    setOnlineSelling(value) {
      this.$store.dispatch("taxInfo/addIncomeValue", {
        name: "onlineSelling",
        value: value,
      });
    },
    setIncomeSalary(value) {
      this.$store.dispatch("taxInfo/addIncomeValue", {
        name: "salary",
        value: value,
      });
    },
    setCost(value) {
      this.$store.dispatch("taxInfo/addExpenseValue", {
        name: "cost",
        value: value,
      });
    },
  },
  computed: {
    validate: function () {
      let valid = false;
      if (this.onlineSelling > 0) {
        valid = true;
      }

      return valid;
    },
  },
};
</script>

<style scoped>
.onlineSelling {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.i-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 351px;
  text-align: center;
  position: relative;
  margin-top: 34px;
}
.ib-title {
  width: 100%;
  border-bottom: 1px solid #acb1bf;
  margin-bottom: 24px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}
.ib-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 16px;
  max-width: 352px;
  text-align: left;
}
.ib-answer {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  max-width: 352px;
}
.ib-footer {
  margin-top: 24px;
  margin-bottom: 31px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  max-width: 352px;
}
.ib-footer .crl-link {
  justify-content: flex-end;
}

.i-loading {
  width: 100%;
  height: 8px;
  background: #e6e8ec;
  position: relative;
}
.il-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 25%;
  height: 100%;
  background: #008fc1;
}
</style>
